import {
  Alert,
  AlertIcon,
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Button,
  ButtonGroup,
  Flex,
  Heading,
  Stack,
  useToast,
} from '@chakra-ui/react';
import WorkTypeResource from 'api/work_type';
import WorkTypeForm from 'components/WorkType/WorkTypeForm';
import { strings } from 'config/localization';
import routes from 'constants/routes';
import { WorkTypeSchema } from 'constants/schema';
import React, { useRef, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useMutation, useQueryClient } from 'react-query';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import { buildFormData } from 'utils';

const CreateWorkType: React.FC = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const form = useRef() as React.MutableRefObject<HTMLFormElement>;
  const history = useHistory();
  const methods = useForm<WorkTypeSchema>();
  const workTypeAPI = new WorkTypeResource();

  const [errorMessage, setErrorMessage] = useState<WorkTypeSchema>();

  const addWorkType = useMutation((data: any) => workTypeAPI.store(data), {
    onSuccess: (res: any) => {
      toast({
        title: strings.work_type_success_msg,
        description: res.data.email,
        status: 'success',
        isClosable: true,
      });
      queryClient.invalidateQueries('workTypeList');
      history.push(routes.workType.list);
    },
    onError: (error: any) => {
      setErrorMessage(error?.response?.data?.errors);
    },
  });

  const onSubmit = (data: any) => {
    const formData = {
      company: data?.company?.value,
      name: data?.name,
      description: data?.description
    }
    addWorkType.mutate(formData);
  };

  return (
    <Stack direction="column" spacing="4">
      <Breadcrumb color="gray.400" size="4">
        <BreadcrumbItem>
          <BreadcrumbLink as={RouterLink} to={routes.workType.list}>
            {strings.work_type}
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbItem isCurrentPage color="gray.900">
          <BreadcrumbLink as={RouterLink} to={routes.workType.create}>
            {strings.add_new_work_type}
          </BreadcrumbLink>
        </BreadcrumbItem>
      </Breadcrumb>

      <Flex justify="space-between">
        <Heading size="md">{strings.add_new_work_type}</Heading>
      </Flex>

      <Box bg="white" p={['3', '6']} shadow="box" rounded="sm">
        <FormProvider {...methods}>
          <form ref={form} onSubmit={methods.handleSubmit(onSubmit)}>
            <Stack direction="column" spacing="4">
              {addWorkType.isError && (
                <Alert status="error">
                  <AlertIcon />
                  {strings.work_type_creation_failed}
                </Alert>
              )}
              <WorkTypeForm />
              <ButtonGroup>
                <Button
                  colorScheme="primary"
                  type="submit"
                  isLoading={addWorkType.isLoading}>
                  {strings.add_work_type}
                </Button>
                <Button variant="outline" onClick={() => history.goBack()}>
                  {strings.cancel}
                </Button>
              </ButtonGroup>
            </Stack>
          </form>
        </FormProvider>
      </Box>
    </Stack>
  );
};

export default CreateWorkType;
